<template>
  <div ref="dropdown" class="btn-group">
    <span ref="dropdownButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      <slot name="button">
        <a class="btn btn-light more" href="javascript:void(0)">...</a>
      </slot>
    </span>
    <div ref="dropdownInner" class="dropdown-menu p-0" :class="position">
      <slot>
        <a class="dropdown-item" href="javascript:void(0)" v-for="(listitem, index) in items" :key="index" @click="listitem.click">{{ listitem.Title }}</a>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /** List item
     * @param {string} Title 
     * @param {Function} click 
     */
    items: {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: 'dropdown-menu-right'
    },
    disableAutoClose: {
      default: false
    }
  },
  data () {
    return {
      expanded: false
    };
  },
  mounted () {
    if (this.$refs.dropdown) {
      const self = this;

      // prevents closing after clicking inside the container
      if (this.disableAutoClose) {
        $(document).on('click', `${this.$refs.dropdown.id} .dropdown-menu`, function (e) {
          e.stopPropagation();
        });
      }

      $(this.$refs.dropdown).on('show.bs.dropdown', function () {
        self.$emit('toggle', true);

        $('body').append($(self.$refs.dropdownInner).css({
          position: 'absolute',
          left: $(self.$refs.dropdownInner).offset().left,
          top: $(self.$refs.dropdownInner).offset().top
        }).detach());
      });
      $(this.$refs.dropdown).on('hide.bs.dropdown', function () {
        self.$emit('toggle', false);
      });
      $(this.$refs.dropdown).on('shown.bs.dropdown', function () {
        self.$emit('toggled', true);
      });
      $(this.$refs.dropdown).on('hidden.bs.dropdown', function () {
        self.$emit('toggled', false);
      });
    }
  },
  beforeDestroy () {
    const self = this;
    $(self.$refs.dropdownInner).remove();
  },
  methods: {
    toggleDropDown () {
      $(this.$refs.dropdownButton).dropdown('toggle');
    }
  }
};
</script>
